export const initializeMetaPixel = () => {
  // Create fbq as a global function
  window.fbq = function() {
    window.fbq.callMethod ? 
    window.fbq.callMethod.apply(window.fbq, arguments) : 
    window.fbq.queue.push(arguments)
  };

  // Initialize fbq
  if (!window._fbq) window._fbq = window.fbq;
  window.fbq.push = window.fbq;
  window.fbq.loaded = true;
  window.fbq.version = '2.0';
  window.fbq.queue = [];

  // Load the Facebook pixel script
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);

  // Initialize the pixel with your ID
  window.fbq('init', '506484575057004');
  window.fbq('track', 'PageView');
};

export const trackPageView = () => {
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
};

export const trackEvent = (eventName, eventData) => {
  if (window.fbq) {
    window.fbq('track', eventName, eventData);
  }
};

/**
 * Fire Meta Pixel Purchase once per booking reference.
 * @param {object} params
 * @param {number} params.value - Final amount charged (GBP)
 * @param {string} [params.currency='GBP']
 * @param {string} [params.eventId] - Booking/order reference for deduplication
 * @param {Array<{id: string, quantity: number, item_price?: number}>} [params.contents]
 * @param {string} [params.contentName]
 */
export const trackPurchase = ({
  value,
  currency = 'GBP',
  eventId,
  contents = [],
  contentName
} = {}) => {
  if (!window.fbq) return;

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue) || numericValue < 0) return;

  // Avoid double-firing on re-renders / Strict Mode / refresh of confirmation
  if (eventId) {
    try {
      const storageKey = `meta_pixel_purchase_${eventId}`;
      if (sessionStorage.getItem(storageKey)) return;
      sessionStorage.setItem(storageKey, '1');
    } catch (e) {
      // sessionStorage unavailable — continue without dedupe
    }
  }

  const normalisedContents = (contents || [])
    .filter(item => item && (item.quantity || 0) > 0)
    .map(item => ({
      id: String(item.id),
      quantity: Number(item.quantity) || 1,
      ...(item.item_price != null && Number.isFinite(Number(item.item_price))
        ? { item_price: Number(item.item_price) }
        : {})
    }));

  const eventData = {
    value: Number(numericValue.toFixed(2)),
    currency,
    content_type: 'product',
    num_items: normalisedContents.reduce((sum, item) => sum + item.quantity, 0) || undefined,
    ...(normalisedContents.length > 0
      ? {
          content_ids: normalisedContents.map(item => item.id),
          contents: normalisedContents
        }
      : {}),
    ...(contentName ? { content_name: contentName } : {})
  };

  if (eventId) {
    window.fbq('track', 'Purchase', eventData, { eventID: String(eventId) });
  } else {
    window.fbq('track', 'Purchase', eventData);
  }
};